import { StringRequired } from '../primitive/string';

export const Forename = StringRequired.annotate({
  message: 'Vyplňte jméno!',
});
